import API from "./API"

export const fetchCropDesignerHash = cropDesignerJson =>
  API.post("/crop-designer-pdf-data/", { crop_designer_data: cropDesignerJson })
